import { render, staticRenderFns } from "./PrizeDetail.vue?vue&type=template&id=44806ec6&scoped=true"
import script from "./PrizeDetail.vue?vue&type=script&lang=js"
export * from "./PrizeDetail.vue?vue&type=script&lang=js"
import style0 from "./PrizeDetail.vue?vue&type=style&index=0&id=44806ec6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44806ec6",
  null
  
)

export default component.exports